import { render } from "./StudentSync.vue?vue&type=template&id=6f60eee6&scoped=true&ts=true"
import script from "./StudentSync.vue?vue&type=script&lang=ts"
export * from "./StudentSync.vue?vue&type=script&lang=ts"

import "./StudentSync.vue?vue&type=style&index=0&id=6f60eee6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f60eee6"]])

export default __exports__